module.exports = __webpack_public_path__ + "img/plant_6_mobile_small.23b26752.webp";